<div class="unlock-dialog">
  <div class="unlock-header">
    <i class="fa-light fa-lock-open"></i>
    <p class="unlock-title">Desbloquear asientos</p>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="unlock-loading">
    <p>Cargando grupos...</p>
  </div>

  <!-- Sin grupos -->
  <div *ngIf="!loading && groups.length === 0 && !error" class="unlock-empty">
    <p>No hay grupos de asientos bloqueados para esta sesión.</p>
  </div>

  <!-- Error -->
  <div *ngIf="error" class="unlock-error">
    <i class="fa-light fa-circle-xmark"></i>
    {{ error }}
  </div>

  <!-- Lista de grupos -->
  <div *ngIf="!loading && groups.length > 0" class="unlock-groups">
    <div class="unlock-select-all" (click)="selectAll()">
      <div class="unlock-checkbox" [class.checked]="allSelected">
        <i class="fa-light fa-check" *ngIf="allSelected"></i>
      </div>
      <span>Seleccionar todos</span>
    </div>

    <div
      *ngFor="let group of groups"
      class="unlock-group"
      [class.unlock-group--selected]="isSelected(group.id)"
      (click)="toggle(group.id)"
    >
      <div class="unlock-checkbox" [class.checked]="isSelected(group.id)">
        <i class="fa-light fa-check" *ngIf="isSelected(group.id)"></i>
      </div>
      <div class="unlock-color" [style.background-color]="group.color"></div>
      <div class="unlock-group-info">
        <p class="unlock-group-name">{{ group.name }}</p>
        <p class="unlock-group-count">{{ group.seats_count }} asiento{{ group.seats_count !== 1 ? 's' : '' }}</p>
      </div>
    </div>
  </div>

  <div class="unlock-actions" *ngIf="!loading">
    <button class="btn-cancel" (click)="cancel()">Cancelar</button>
    <button
      class="btn-unlock"
      [disabled]="selectedIds.size === 0 || unlocking"
      (click)="unlock()"
    >
      <i class="fa-light fa-lock-open"></i>
      {{ unlocking ? 'Desbloqueando...' : 'Desbloquear' }}
    </button>
  </div>
</div>
